import { lensPath, view} from 'ramda';
import * as RA from 'ramda-adjunct';

import * as D from 'date-fns';
import * as S from 'sanctuary';
import { DataStates } from "../../../store/global/data-state";
import { JSONX } from '../../../utility';


export const defaultBookingOverview = () => {
  return {
    dataState: DataStates.LOADING,
    ...{
      currencies: [],
      cdate: {
        notes: '',
        first_offer_notes: ''
      },
      artists: [],
      users: [],
      countries: []
    }
  };
};


export const isCalendarDateIdValid = (calendarDateId, throwError = false) => {
  if (parseInt(calendarDateId) > 0) {
    return parseInt(calendarDateId);
  } else if (throwError) {
    throw Error('Calendar Date Id is not valid');
  } else {
    return false;
  }
}

export const startDateLens = lensPath(['data', 'cdate', 'start_date']);
export const startDateView = view(startDateLens);

export const contactIdPromoterLens = lensPath(['cdate', 'contact_id_promoter']);
export const contactIdPromoterView = view(contactIdPromoterLens);

export const usersLens = lensPath(['users']);
export const usersView = RA.viewOr([], usersLens);

export const userLens = lensPath(['bookingOverview', 'user']);
export const userView = RA.viewOr({}, userLens);

// export const createBookingFlat = (booking, artist_id) => {
//   const artist = booking?.artists?.find(a => a.artist_id == artist_id) || {};
//   const cdate = booking?.cdate || {};
//   const location = booking?.location || {};
//   const promoter = booking?.promoter || {};

//   return {
//     start_date: cdate?.start_date || '',
//     booking_location_name: location?.booking_location_name || '',
//     city: location?.city || '',
//     country: location?.country || '',
//     first_offer_notes: artist?.first_offer_notes || '',
//     email_to: artist?.email1 || '',
//     artist: artist?.artist_name || '',
//     performance_type: artist?.performance_type || '',
//     event_name: '',
//     notes_ical: cdate?.notes,
//     calendar_date_id: cdate?.calendar_date_id,
//     venue_name: location?.booking_location_name,
//     venue_address: location?.address1,
//     venue_city: location?.city,
//     venue_postalcode: location?.postalcode || '',
//     venue_country: location?.country || '',
//     venue_phone: location?.phone1 || '',
//     venue_email: location?.email || '',
//     venue_url: location?.url1 || '',
//     venue_capacity: location?.venue_capacity || '',
//     promoter_company_name: promoter.company_name,
//     promoter_representative: promoter.representative,
//     promoter_address: promoter.address,
//     promoter_city: promoter.city,
//     promoter_postalcode: promoter.postalcode,
//     promoter_state: promoter.state,
//     promoter_country: promoter.country,
//     promoter_phone: promoter.phone1,
//     promoter_mobile: promoter.mobile1,
//     promoter_email: promoter.email1,
//     promoter_vat_id: promoter.vat_id,
//     promoter_url: promoter.url,
//     promoter_language: promoter.language,
//     template_key: '',
//     section: '',
//     template_id: '',
//     subject: '',
//     action: '',
//   }
// }

export const createBookingOverview = ({
  section = '',
  deal_summary = '',
  countries = [''],
  status = createStatus({}),
  promoter2 = createPromoter2({}),
  promoter = createPromoter({}),
  invoices = [createInvoices({})],
  action = '',
  location = createLocation({}),
  currencies = [createCurrencies({})],
  user = createUser({}),
  staff = createStaff({}),
  booking_invoice_status = '',
  booking_header = '',
  promoter_id = 0,
  cdate = createCdate({}),
  client = createClient({}),
  checksum = '',
  link_url = '',
  travel_detail_confirmed_flag = 0,
  users = [createUsers({})],
  booking_status = [createBooking_status({})],
  artists = [createArtists({})]
} = {}) => {
  return {
    section,
    deal_summary,
    countries,
    status: createStatus(status),
    promoter2: createPromoter2(promoter2),
    promoter: createPromoter(promoter),
    invoices: invoices.map(createInvoices),
    action,
    location: createLocation(location),
    currencies: currencies.map(createCurrencies),
    user: createUser(user),
    staff: createStaff(staff),
    booking_invoice_status,
    booking_header,
    promoter_id,
    cdate: createCdate(cdate),
    client: createClient(client),
    checksum,
    link_url,
    travel_detail_confirmed_flag,
    users: users.map(createUsers),
    booking_status: booking_status.map(createBooking_status),
    artists: artists.map(createArtists)
  }
};


const createStatus = ({
  finance = createFinance({}),
  travel = createTravel({}),
  artist = createArtist({})
} = {}) => {
  return {
    finance: createFinance(finance),
    travel: createTravel(travel),
    artist: createArtist(artist)
  }
};


const createFinance = ({
  summary1 = '',
  summary3 = '',
  summary2 = ''
} = {}) => {
  return {
    summary1,
    summary3,
    summary2
  }
};



const createTravel = ({
  ok = 0,
  summary = ''
} = {}) => {
  return {
    ok,
    summary
  }
};



const createArtist = ({
  summary = '',
  ok = 0
} = {}) => {
  return {
    summary,
    ok
  }
};




const createPromoter2 = ({
  email2 = '',
  formality = undefined,
  language = undefined,
  nick_name = undefined,
  last_name = '',
  cost_discount_percent = undefined,
  invoice_discount_days = undefined,
  birthdate = undefined,
  company_legalname = '',
  cost_center = undefined,
  email1 = '',
  account_holder = undefined,
  valid_vat_no_flag = 0,
  title = undefined,
  last_modified = '',
  default_declaration_text2 = undefined,
  region = '',
  mobile2 = undefined,
  fax2 = undefined,
  cost_payment_method_id = undefined,
  cost_due_days = undefined,
  invoice_end_of_month_flag = undefined,
  notes = undefined,
  fax1 = '',
  city = '',
  address2 = '',
  url3 = undefined,
  url1 = undefined,
  url4 = undefined,
  iCal_password = undefined,
  request = undefined,
  default_declaration_text1 = undefined,
  phone1 = '',
  vat_type_id = undefined,
  invoice_discount_percent = undefined,
  company_name = undefined,
  gender = undefined,
  debitor_no = undefined,
  contact_id = 0,
  mobile1 = undefined,
  customer_no = undefined,
  tax_no = undefined,
  account_no = undefined,
  first_name = '',
  date_end = undefined,
  main_promoter = undefined,
  iban = undefined,
  vat_no = undefined,
  bank_address = undefined,
  cost_end_of_month_flag = undefined,
  vat_no_confirmed = undefined,
  sortcode = undefined,
  country = '',
  chat3 = '',
  invoice_due_days = undefined,
  creditor_no = undefined,
  url2 = undefined,
  currency_id = undefined,
  passport_no = undefined,
  date_start = undefined,
  phone2 = 0,
  postbox = undefined,
  cost_discount_days = undefined,
  swift = undefined,
  invoice_payment_method_id = undefined,
  created = '',
  bank_name = undefined,
  postalcode = 0,
  skype = undefined,
  aim = undefined,
  address1 = ''
} = {}) => {
  return {
    email2,
    formality,
    language,
    nick_name,
    last_name,
    cost_discount_percent,
    invoice_discount_days,
    birthdate,
    company_legalname,
    cost_center,
    email1,
    account_holder,
    valid_vat_no_flag,
    title,
    last_modified,
    default_declaration_text2,
    region,
    mobile2,
    fax2,
    cost_payment_method_id,
    cost_due_days,
    invoice_end_of_month_flag,
    notes,
    fax1,
    city,
    address2,
    url3,
    url1,
    url4,
    iCal_password,
    request,
    default_declaration_text1,
    phone1,
    vat_type_id,
    invoice_discount_percent,
    company_name,
    gender,
    debitor_no,
    contact_id,
    mobile1,
    customer_no,
    tax_no,
    account_no,
    first_name,
    date_end,
    main_promoter,
    iban,
    vat_no,
    bank_address,
    cost_end_of_month_flag,
    vat_no_confirmed,
    sortcode,
    country,
    chat3,
    invoice_due_days,
    creditor_no,
    url2,
    currency_id,
    passport_no,
    date_start,
    phone2,
    postbox,
    cost_discount_days,
    swift,
    invoice_payment_method_id,
    created,
    bank_name,
    postalcode,
    skype,
    aim,
    address1
  }
};



const createPromoter = ({
  postbox = undefined,
  cost_discount_days = undefined,
  phone2 = 0,
  url2 = undefined,
  date_start = undefined,
  passport_no = undefined,
  currency_id = undefined,
  aim = undefined,
  postalcode = 0,
  address1 = '',
  skype = undefined,
  created = '',
  bank_name = undefined,
  swift = undefined,
  invoice_payment_method_id = undefined,
  sortcode = undefined,
  vat_no_confirmed = undefined,
  vat_no = undefined,
  iban = undefined,
  main_promoter = undefined,
  cost_end_of_month_flag = undefined,
  bank_address = undefined,
  date_end = undefined,
  first_name = '',
  account_no = undefined,
  creditor_no = undefined,
  invoice_due_days = undefined,
  country = '',
  chat3 = '',
  default_declaration_text1 = undefined,
  request = undefined,
  iCal_password = undefined,
  phone1 = '',
  url4 = undefined,
  url1 = undefined,
  url3 = undefined,
  address2 = '',
  city = '',
  fax1 = '',
  notes = undefined,
  mobile1 = undefined,
  tax_no = undefined,
  customer_no = undefined,
  contact_id = 0,
  gender = undefined,
  debitor_no = undefined,
  company_name = undefined,
  invoice_discount_percent = undefined,
  vat_type_id = undefined,
  cost_center = undefined,
  email1 = '',
  company_legalname = '',
  invoice_discount_days = undefined,
  birthdate = undefined,
  last_name = '',
  cost_discount_percent = undefined,
  email2 = '',
  nick_name = undefined,
  formality = undefined,
  language = undefined,
  cost_due_days = undefined,
  cost_payment_method_id = undefined,
  invoice_end_of_month_flag = undefined,
  region = '',
  fax2 = undefined,
  mobile2 = undefined,
  last_modified = '',
  default_declaration_text2 = undefined,
  account_holder = undefined,
  title = undefined,
  valid_vat_no_flag = 0
} = {}) => {
  return {
    postbox,
    cost_discount_days,
    phone2,
    url2,
    date_start,
    passport_no,
    currency_id,
    aim,
    postalcode,
    address1,
    skype,
    created,
    bank_name,
    swift,
    invoice_payment_method_id,
    sortcode,
    vat_no_confirmed,
    vat_no,
    iban,
    main_promoter,
    cost_end_of_month_flag,
    bank_address,
    date_end,
    first_name,
    account_no,
    creditor_no,
    invoice_due_days,
    country,
    chat3,
    default_declaration_text1,
    request,
    iCal_password,
    phone1,
    url4,
    url1,
    url3,
    address2,
    city,
    fax1,
    notes,
    mobile1,
    tax_no,
    customer_no,
    contact_id,
    gender,
    debitor_no,
    company_name,
    invoice_discount_percent,
    vat_type_id,
    cost_center,
    email1,
    company_legalname,
    invoice_discount_days,
    birthdate,
    last_name,
    cost_discount_percent,
    email2,
    nick_name,
    formality,
    language,
    cost_due_days,
    cost_payment_method_id,
    invoice_end_of_month_flag,
    region,
    fax2,
    mobile2,
    last_modified,
    default_declaration_text2,
    account_holder,
    title,
    valid_vat_no_flag
  }
};



const createInvoices = ({
  gross_amount_cc = 0,
  invioce_project_email_address = undefined,
  company_name = undefined,
  first_name = '',
  invoice_ref = '',
  color = '',
  last_name = '',
  invoice_date = '',
  invoice_id = 0,
  invoice_project_name = '',
  currency_iso = '',
  subject = '',
  paypal_email = undefined
} = {}) => {
  return {
    gross_amount_cc,
    invioce_project_email_address,
    company_name,
    first_name,
    invoice_ref,
    color,
    last_name,
    invoice_date,
    invoice_id,
    invoice_project_name,
    currency_iso,
    subject,
    paypal_email
  }
};



const createLocation = ({
  ksk_info = undefined,
  mechanical_info = '',
  google_place_id = '',
  address1 = '',
  postalcode = 0,
  created = '',
  feature = undefined,
  longitude = undefined,
  booking_location_name = '',
  latitude = undefined,
  fax = undefined,
  dist_to_airport = undefined,
  phone1 = '',
  phone2 = undefined,
  address2 = undefined,
  url1 = undefined,
  url2 = undefined,
  city = '',
  keywords = undefined,
  type = '',
  sponsoring_info = undefined,
  opening_time = undefined,
  market_area = '',
  merchandise_info = '',
  last_modified = '',
  country = '',
  original_id = undefined,
  age_limit = undefined,
  curfew = undefined,
  booking_location_id = 0,
  email = undefined,
  venue_capacity = 0,
  clientID = undefined
} = {}) => {
  return {
    ksk_info,
    mechanical_info,
    google_place_id,
    address1,
    postalcode,
    created,
    feature,
    longitude,
    booking_location_name,
    latitude,
    fax,
    dist_to_airport,
    phone1,
    phone2,
    address2,
    url1,
    url2,
    city,
    keywords,
    type,
    sponsoring_info,
    opening_time,
    market_area,
    merchandise_info,
    last_modified,
    country,
    original_id,
    age_limit,
    curfew,
    booking_location_id,
    email,
    venue_capacity,
    clientID
  }
};



const createCurrencies = ({
  exchange_rate = 0,
  currency_k_sep = undefined,
  currency_name = '',
  currency_d_sep = undefined,
  currency_iso = '',
  created = '',
  currency_decimals = undefined,
  currency_id = 0,
  last_modified = '',
  currency_sign = '',
  currency_minus_leading = undefined,
  currency_sign_type = undefined,
  currency_minus_trailing = undefined
} = {}) => {
  return {
    exchange_rate,
    currency_k_sep,
    currency_name,
    currency_d_sep,
    currency_iso,
    created,
    currency_decimals,
    currency_id,
    last_modified,
    currency_sign,
    currency_minus_leading,
    currency_sign_type,
    currency_minus_trailing
  }
};



const createUser = ({
  contact_export_import_flag = 0,
  module_settings_flag = 0,
  dashboard_settings = createDashboard_settings({}),
  client_code = undefined,
  booking_report_flag = 0,
  distribution_flag = 0,
  contact_id = undefined,
  publishing_more_flag = 0,
  created = '',
  general_more_flag = 0,
  user_name = '',
  staff_email = '',
  general_flag = 0,
  accounting_more_flag = 0,
  staff_fullname = undefined,
  staff_phone1 = undefined,
  user_settings_flag = 0,
  general_settings_flag = 0,
  smtp_password = undefined,
  label_flag = 0,
  permissions = createPermissions({}),
  smtp_username = undefined,
  password = '',
  booking_more_flag = 0,
  user_id = 0,
  language = '',
  label_more_flag = 0,
  smtp_server = undefined,
  management_flag = 0,
  promotion_flag = 0,
  publishing_flag = 0,
  signature_link = undefined,
  job_title = undefined,
  accounting_flag = 0,
  booking_flag = 0,
  staff_phone2 = undefined,
  last_modified = '',
  contacts_flag = 0
} = {}) => {
  return {
    contact_export_import_flag,
    module_settings_flag,
    dashboard_settings: createDashboard_settings(dashboard_settings),
    client_code,
    booking_report_flag,
    distribution_flag,
    contact_id,
    publishing_more_flag,
    created,
    general_more_flag,
    user_name,
    staff_email,
    general_flag,
    accounting_more_flag,
    staff_fullname,
    staff_phone1,
    user_settings_flag,
    general_settings_flag,
    smtp_password,
    label_flag,
    permissions: createPermissions(permissions),
    smtp_username,
    password,
    booking_more_flag,
    user_id,
    language,
    label_more_flag,
    smtp_server,
    management_flag,
    promotion_flag,
    publishing_flag,
    signature_link,
    job_title,
    accounting_flag,
    booking_flag,
    staff_phone2,
    last_modified,
    contacts_flag
  }
};




const createStaff = ({
  last_modified = '',
  contacts_flag = 0,
  staff_phone2 = undefined,
  booking_flag = 0,
  accounting_flag = 0,
  job_title = undefined,
  publishing_flag = 0,
  signature_link = '',
  promotion_flag = 0,
  management_flag = 0,
  smtp_server = undefined,
  label_more_flag = 0,
  language = '',
  user_id = 0,
  booking_more_flag = 0,
  permissions = createPermissions({}),
  password = '',
  smtp_username = undefined,
  label_flag = 0,
  smtp_password = undefined,
  user_settings_flag = 0,
  general_settings_flag = 0,
  staff_fullname = '',
  staff_phone1 = undefined,
  accounting_more_flag = 0,
  general_flag = 0,
  staff_email = '',
  user_name = '',
  general_more_flag = 0,
  created = '',
  publishing_more_flag = 0,
  contact_id = undefined,
  distribution_flag = 0,
  client_code = undefined,
  booking_report_flag = 0,
  dashboard_settings = createDashboard_settings({}),
  module_settings_flag = 0,
  contact_export_import_flag = 0
} = {}) => {
  return {
    last_modified,
    contacts_flag,
    staff_phone2,
    booking_flag,
    accounting_flag,
    job_title,
    publishing_flag,
    signature_link,
    promotion_flag,
    management_flag,
    smtp_server,
    label_more_flag,
    language,
    user_id,
    booking_more_flag,
    permissions: createPermissions(permissions),
    password,
    smtp_username,
    label_flag,
    smtp_password,
    user_settings_flag,
    general_settings_flag,
    staff_fullname,
    staff_phone1,
    accounting_more_flag,
    general_flag,
    staff_email,
    user_name,
    general_more_flag,
    created,
    publishing_more_flag,
    contact_id,
    distribution_flag,
    client_code,
    booking_report_flag,
    dashboard_settings: createDashboard_settings(dashboard_settings),
    module_settings_flag,
    contact_export_import_flag
  }
};






const createCdate = ({
  currency_id = 0,
  city = '',
  budget_due_date = undefined,
  first_offer_notes = '',
  IATA = undefined,
  notes = undefined,
  request = 0,
  itinerary_artist_flag = undefined,
  contracts_out_flag = undefined,
  get_in = undefined,
  booking_event_id = undefined,
  local_send_flag = '',
  local_lock_flag = undefined,
  riders_out_flag = undefined,
  end_date = '',
  artist_lock_flag = undefined,
  date_name = '',
  doors_open = undefined,
  start_date = '',
  created = '',
  contracts_sent_date = undefined,
  artist_send_flag = '',
  invoice_line_id1 = undefined,
  questionnaire_sent = undefined,
  itinerary_promoter_flag = undefined,
  contact_id_promoter2 = 0,
  invoice_line_id2 = undefined,
  event_url = undefined,
  curfew = undefined,
  calendar_date_id = 0,
  contracts_signed_flag = undefined,
  user_id = 0,
  lineup = undefined,
  booking_tour_id = 0,
  travel_lock_flag = undefined,
  booking_location_id = 0,
  local_info = undefined,
  last_modified = '',
  itinerary_info_flag = undefined,
  country = '',
  first_offer = undefined,
  travel_send_flag = '',
  ticket_price = undefined,
  contact_id_promoter = 0,
  local_details_confirmed_flag = undefined,
  invoices_out_flag = undefined
} = {}) => {
  return {
    currency_id,
    city,
    budget_due_date,
    first_offer_notes,
    IATA,
    notes,
    request,
    itinerary_artist_flag,
    contracts_out_flag,
    get_in,
    booking_event_id,
    local_send_flag,
    local_lock_flag,
    riders_out_flag,
    end_date,
    artist_lock_flag,
    date_name,
    doors_open,
    start_date,
    created,
    contracts_sent_date,
    artist_send_flag,
    invoice_line_id1,
    questionnaire_sent,
    itinerary_promoter_flag,
    contact_id_promoter2,
    invoice_line_id2,
    event_url,
    curfew,
    calendar_date_id,
    contracts_signed_flag,
    user_id,
    lineup,
    booking_tour_id,
    travel_lock_flag,
    booking_location_id,
    local_info,
    last_modified,
    itinerary_info_flag,
    country,
    first_offer,
    travel_send_flag,
    ticket_price,
    contact_id_promoter,
    local_details_confirmed_flag,
    invoices_out_flag
  }
};



const createClient = ({
  display_name = ''
} = {}) => {
  return {
    display_name
  }
};



const createUsers = ({
  accounting_flag = 0,
  job_title = '',
  last_modified = '',
  contacts_flag = 0,
  booking_flag = 0,
  staff_phone2 = '',
  publishing_flag = undefined,
  signature_link = undefined,
  promotion_flag = 0,
  smtp_server = undefined,
  language = '',
  label_more_flag = undefined,
  management_flag = 0,
  general_settings_flag = 0,
  user_settings_flag = undefined,
  label_flag = 0,
  smtp_password = undefined,
  staff_phone1 = '',
  staff_fullname = '',
  booking_more_flag = undefined,
  user_id = 0,
  permissions = createPermissions({}),
  smtp_username = undefined,
  password = '',
  accounting_more_flag = 0,
  staff_email = '',
  general_flag = undefined,
  created = '',
  publishing_more_flag = undefined,
  contact_id = undefined,
  user_name = '',
  general_more_flag = undefined,
  distribution_flag = 0,
  module_settings_flag = undefined,
  dashboard_settings = createDashboard_settings({}),
  contact_export_import_flag = 0,
  booking_report_flag = 0,
  client_code = ''
} = {}) => {
  return {
    accounting_flag,
    job_title,
    last_modified,
    contacts_flag,
    booking_flag,
    staff_phone2,
    publishing_flag,
    signature_link,
    promotion_flag,
    smtp_server,
    language,
    label_more_flag,
    management_flag,
    general_settings_flag,
    user_settings_flag,
    label_flag,
    smtp_password,
    staff_phone1,
    staff_fullname,
    booking_more_flag,
    user_id,
    permissions: createPermissions(permissions),
    smtp_username,
    password,
    accounting_more_flag,
    staff_email,
    general_flag,
    created,
    publishing_more_flag,
    contact_id,
    user_name,
    general_more_flag,
    distribution_flag,
    module_settings_flag,
    dashboard_settings: createDashboard_settings(dashboard_settings),
    contact_export_import_flag,
    booking_report_flag,
    client_code
  }
};


const createPermissions = (payload) => {
  const parsed = JSONX.tryParse(payload);
  console.log(parsed);
  if (parsed.success) {
    payload = parsed.result;
  } else {
    return payload;
  }
  const {
    allowed = createAllowed({}),
    blocked = createBlocked({})
  } = payload;

  return {
    allowed: createAllowed(allowed),
    blocked: createBlocked(blocked)
  }
};


const createAllowed = ({
  roles = ['']
} = {}) => {
  return {
    roles
  }
};



const createBlocked = ({
  modules = [''],
  tabs = [''],
  sub_menu = [''],
  booking_artists = [0],
  invoice_projects = [0]
} = {}) => {
  return {
    modules,
    tabs,
    sub_menu,
    booking_artists,
    invoice_projects
  }
};




const createDashboard_settings = ({

} = {}) => {
  return {

  }
};




const createBooking_status = ({
  hide_free_on_date_flag = undefined,
  created = '',
  booking_status_name = '',
  publish_to_website_flag = 0,
  booking_status_id = 0,
  booking_status_colour = '',
  publish_to_artist_flag = 0,
  default_status_booking_flag = 0,
  last_modified = ''
} = {}) => {
  return {
    hide_free_on_date_flag,
    created,
    booking_status_name,
    publish_to_website_flag,
    booking_status_id,
    booking_status_colour,
    publish_to_artist_flag,
    default_status_booking_flag,
    last_modified
  }
};



const createArtists = ({
  calendar_date_id = 0,
  performance_type = '',
  soundcheck = undefined,
  default_agent_commission = undefined,
  performance_time = undefined,
  artist_name = '',
  email1 = '',
  stage_name = undefined,
  booking_status_colour = '',
  booking_status_name = '',
  artist_before = undefined,
  first_offer_notes = undefined,
  schedule_notes = undefined,
  performance_time_contract = undefined,
  contract_flag = undefined,
  first_name = '',
  nick_name = undefined,
  booking_location_stage_name = undefined,
  calendar_date_artist_id = 0,
  booking_status_id = 0,
  booking_location_stage_id = undefined,
  artist_after = undefined,
  last_modified = '',
  confirmed_flag = undefined,
  artist_id = 0
} = {}) => {
  return {
    calendar_date_id,
    performance_type,
    soundcheck,
    default_agent_commission,
    performance_time,
    artist_name,
    email1,
    stage_name,
    booking_status_colour,
    booking_status_name,
    artist_before,
    first_offer_notes,
    schedule_notes,
    performance_time_contract,
    contract_flag,
    first_name,
    nick_name,
    booking_location_stage_name,
    calendar_date_artist_id,
    booking_status_id,
    booking_location_stage_id,
    artist_after,
    last_modified,
    confirmed_flag,
    artist_id
  }
};



